export default __webpack_public_path__ + "static/media/ncp.334758e9.jpg";